import React, { useState, useEffect } from 'react';
import { Copy, Check, FileText } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './TextRenderer.module.css';
import ContentHeader from '../ContentHeader';
import ContentSkeleton from '../ContentSkeleton';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3, ease: [0.16, 1, 0.3, 1] },
  },
};

const TextRenderer = ({ contentDetails, viewerUrl }) => {
  console.log(contentDetails);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const response = await fetch(viewerUrl);
        if (!response.ok) {
          throw new Error('Failed to fetch content');
        }
        const text = await response.text();
        setContent(text);
      } catch (err) {
        console.error(err);
        setError('Failed to load text content.');
      } finally {
        setLoading(false);
      }
    };

    if (viewerUrl) {
      fetchContent();
    }
  }, [viewerUrl]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text', err);
    }
  };

  if (loading) {
    return (
      <motion.div
        key="skeleton"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        style={{ width: '100%' }}
      >
        <ContentSkeleton />
      </motion.div>
    );
  }

  if (error) {
    return (
      <div className={styles.centerContainer}>
        <div className={styles.error}>{error}</div>
      </div>
    );
  }

  return (
    <motion.div
      className={styles.container}
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {/* <motion.div className={styles.header} variants={itemVariants}>
        <div className={styles.fileInfo}>
          <FileText size={18} className={styles.icon} />
          <span className={styles.title}>
            {contentDetails?.metadata?.file_metadata?.name || 'Text Document'}
          </span>
        </div>
        <motion.button
          onClick={handleCopy}
          className={styles.copyButton}
          aria-label="Copy content"
          title="Copy content"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.96 }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
        >
          <AnimatePresence mode="wait" initial={false}>
            {copied ? (
              <motion.span
                key="copied"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.15 }}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <Check size={16} className={styles.successIcon} />
                <span>Copied</span>
              </motion.span>
            ) : (
              <motion.span
                key="copy"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.15 }}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <Copy size={16} />
                <span>Copy</span>
              </motion.span>
            )}
          </AnimatePresence>
        </motion.button>
      </motion.div>*/}

      <ContentHeader
        title={
          contentDetails?.title ||
          contentDetails?.metadata?.file_metadata?.name ||
          contentDetails?.file_name ||
          'Text Document'
        }
        url={viewerUrl}
        config={contentDetails?.metadata?.configurations || {}}
      />
      <motion.div className={styles.contentWrapper} variants={itemVariants}>
        {/* <pre className={styles.pre}>
          <code>{content}</code>
        </pre>*/}

        <div className={styles.pre}>{content}</div>
      </motion.div>
    </motion.div>
  );
};

export default TextRenderer;